import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmailVerificationPage } from '@/features/auth/signup/pages/EmailVerificationPage.tsx';
import { authRoute } from '@/App.tsx';

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const emailVerificationRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/email-verification',
  component: EmailVerificationPage,
  validateSearch: searchSchema,
});
